import {FC, useState} from "react";
import IconInfo from "../../assets/icons/info-italic.svg";
import IconCloseModal from "../../assets/icons/close.svg";
import {CustomDarkContainer} from "../../ui/CustomDarkContainer";
import {Dialog, DialogTitle, GlobalStyles, Modal} from "@mui/material";
import SidebarInfoMapTehnology from "../SidebarInfo/MapTehnology";
import {ITypeRadar} from "../../types";
import SidebarInfoFinTech from "../SidebarInfo/FinTech";
import SidebarInfoStateInitiative from "../SidebarInfo/StateInitiative";

interface Iprops {
  typeRadar: ITypeRadar;
}
export const AboutRadarTop: FC<Iprops> = ({typeRadar}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const renderContent = () => {
    switch (typeRadar) {
      case "map":
        return <SidebarInfoMapTehnology />;
      case "fintech":
        return <SidebarInfoFinTech />;
      case "stateInitiative":
        return <SidebarInfoStateInitiative />;
      //   case "weakSignals":
      //     return <SideBarInfoWeakSignals />;
      default:
        return <SidebarInfoMapTehnology />;
    }
  };
  const renderTitle = () => {
    switch (typeRadar) {
      case "map":
        return " Карты технологий";
      case "fintech":
        return " FinTech";
      case "stateInitiative":
        return " ЦРГЦИ";
      //   case "weakSignals":
      //     return "Слабые сигналы";
      default:
        return " Карты технологий";
    }
  };

  return (
    <>
      <GlobalStyles
        styles={{
          ".MuiDialog-paper": {
            scrollbarWidth: "thin",
            scrollbarColor: "#444 #222",
          },
          ".MuiDialog-paper::-webkit-scrollbar": {
            width: "8px",
            background: "#222",
            borderRadius: "8px",
          },
          ".MuiDialog-paper::-webkit-scrollbar-thumb": {
            background: "#444",
            borderRadius: "8px",
          },
          ".MuiDialog-paper::-webkit-scrollbar-track": {
            background: "#222",
            borderRadius: "8px",
          },
        }}
      />
      <CustomDarkContainer isButton onOpenModel={() => setIsOpenModal(true)}>
        <img src={IconInfo} alt="" />
        <span>О радаре</span>
      </CustomDarkContainer>
      <Dialog
        open={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        maxWidth="xl"
        PaperProps={{
          sx: {
            backgroundColor: "#161a1d",
            color: "#FAFAFA",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "12px",
            maxWidth: "1000px",
            overflow: "hidden",
          },
        }}
      >
        <div
          style={{
            maxHeight: "80vh",
            overflowY: "auto",
            borderRadius: "12px",
          }}
        >
          <DialogTitle
            style={{
              position: "sticky",
              top: 0,
              backgroundColor: "#161a1d",
              zIndex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              color: "rgba( 255, 255, 255, 0.6 )",
              fontWeight: "200",
            }}
          >
            <div>
              Методология{" "}
              <span style={{color: "#fafafa", fontWeight: "600"}}>
                {renderTitle()}
              </span>
            </div>
            <img
              src={IconCloseModal}
              alt="close"
              style={{cursor: "pointer"}}
              onClick={() => setIsOpenModal(false)}
            />
          </DialogTitle>
          {renderContent()}
        </div>
      </Dialog>
    </>
  );
};
